export const GetYear = async (year) => {
  const response = await fetch(
    `${process.env.VUE_APP_API_BASE_URL}/years/${year}`
  );
  return await response.json();
};

export const updateYear = async (pass, year, column, value) => {
  const response = await fetch(
    `${process.env.VUE_APP_API_BASE_URL}/years/${year}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${pass}`,
      },
      body: JSON.stringify({
        column: column,
        value: value,
      }),
    }
  );
  return await response.json();
};
